module.exports = __webpack_public_path__ + "img/notify.8271cfd0.svg";